import React from 'react';
import { Text, CustomSVG, Empty } from '../../../components';
import { LoadableValue, SKELETON_WIDTH } from '../CardLoadingUtils';

import { CpuIcon, RamIcon, StorageIcon } from '../../../components/icons';

import { getCriteriaIcon } from '../../../pages/Discovery/Inventory/components/DiscoveryInventoryTable/components/StorageAndMemoryCriteria/CriteriaIcons';

const metrics = [
    { key: 'cpu', svg: <CpuIcon />, criteriaKey: 'cpuCriteria', unit: 'vCPU' },
    { key: 'ram', svg: <RamIcon />, criteriaKey: 'ramCriteria', unit: 'GiB' },
    { key: 'storage', svg: <StorageIcon />, criteriaKey: 'storageCriteria', unit: 'GiB' },
];

export const ContentRow = ({ details, loading }) => {
    if (!loading && details.length === 0) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data available" />;
    }

    return details.map((item, index) => {
        const { text } = item;
        return (
            <div key={index} className="content-row">
                <Text size="small" extraBold color="muted">
                    <LoadableValue isLoading={loading} width={SKELETON_WIDTH.large}>
                        {text}
                    </LoadableValue>
                </Text>
                <div className="metrics">
                    {metrics.map(({ key, svg, criteriaKey, unit }) => {
                        const raw = item[key];
                        if (!loading && raw == null) return null;
                        const displayValue = typeof raw === 'object' ? raw.value : raw;
                        const displayUnit = typeof raw === 'object' ? raw.unit : unit;
                        return (
                            <div key={key}>
                                {svg}
                                {!loading && getCriteriaIcon(item[criteriaKey])}
                                <Text size="small" color="secondary">
                                    <LoadableValue isLoading={loading} width={SKELETON_WIDTH.medium}>
                                        <Text color="primaryBlue" xxlBold className="metric-value">
                                            {displayValue}
                                        </Text>{' '}
                                        {displayUnit}
                                    </LoadableValue>
                                </Text>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    });
};
